module.exports = __webpack_public_path__ + "static/suffolk-therapy-fields-0ebb644f28138b71c21f30504e6aa64b.jpg";